// extracted by mini-css-extract-plugin
export var closeButton = "_2r-3";
export var header = "_2r-0";
export var link = "_2r-1";
export var retryButton = "_2r-2";